var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tool-container"},[_c(_vm.activeToolComponent,{tag:"component"}),(_vm.helpActive)?_c('HelpDocuments'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }